// A temporary component to render HeroBentoModule for non-NAMER regions
import * as React from 'react';

import { HeroBentoModule } from '@coursera-web/cds-labs';

import { useCampaignModulesData } from 'bundles/campaigns/context/CampaignModulesDataContext';
import getPredefinedPromos from 'bundles/front-page/redesign-modules/hero-banner/data/getPredefinedPromos';

const NonNamerHeroBentoModuleRenderer = () => {
  const moduleData = useCampaignModulesData()?.campaignData?.heroModule;

  const content = moduleData?.contentDataJson || {};

  const campaignCard = {
    id: content?.sys.id,
    ...content,
    eyebrow: {
      image: content?.eyebrowImage,
      eyebrowImageHeight: content?.eyebrowImageHeight ?? 12,
    },
    cta: {
      target: content?.ctaTarget,
      label: content?.ctaText,
    },
    desktopImage: {
      ...content?.image,
    },
    mobileImage: {
      ...(content?.mobileImage ?? content?.image),
    },
  };

  const defaultCards = getPredefinedPromos();
  // Manually construct the cards array to ensure the campaign card is in the middle
  // to match NAMER campaign entry: https://app.contentful.com/spaces/00atxywtfxvd/entries/1zVMbc7d9BYf9ei3qO1jxq?previousEntries=4Imvh3fNXcjKCj7suTIJ5f%2C386VQqiFPiWtqKLIuP3AKm%2C37yKGSOUzv9Pku5OaUMD5Q&focusedField=entryTitle
  const itemCards = [defaultCards.joinForFree, campaignCard, defaultCards.c4b].map((item, index) => {
    return {
      ...item,
      index,
      campaignEventingData: {
        id: moduleData?.campaignId ?? '',
        matchedCountryCode: moduleData?.matchedCountryCode ?? '',
        epicExperimentId: moduleData?.epicExperimentId ?? '',
        regionName: moduleData?.regionName ?? '',
        name: moduleData?.campaignName ?? '',
      },
    };
  });

  return <HeroBentoModule cards={itemCards} />;
};

export default NonNamerHeroBentoModuleRenderer;
